export const listQueueNames = (context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.queue.listQueueNames(
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const listQueueThings = (queueName: string, context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.queue.listQueueThings(
      queueName,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const listQueuePartitions = (
  queueName: string,
  thingId: number,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.queue.listQueuePartitions(
      queueName,
      thingId,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const loadQueueData = (
  queueName: string,
  thingId: number,
  partition: number,
  startBucket: number,
  startTimestamp: number,
  startUid: number,
  limit: number,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.queue.loadQueueData(
      queueName,
      thingId,
      partition,
      startBucket,
      startTimestamp,
      startUid,
      limit,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const deleteQueueEntry = (
  queueName: string,
  thingId: number,
  partition: number,
  bucket: number,
  timestamp: number,
  uid: number,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.queue.deleteQueueEntry(
      queueName,
      thingId,
      partition,
      bucket,
      timestamp,
      uid,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}
